import React from 'react';

function PublicOffer() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 md:p-10">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Публичная оферта
            </h1>
            <p className="text-sm text-gray-500">
              Версия 1.1 от 17 января 2025 г.
            </p>
          </div>

          <div className="prose prose-sm md:prose-base max-w-none text-gray-700 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Общие положения</h2>
              <p>
                Настоящий документ является публичной офертой (далее — «Оферта») Индивидуального предпринимателя 
                Вихляева Сергея Николаевича (далее — «Исполнитель») о заключении договора оказания услуг 
                на условиях, изложенных ниже.
              </p>
              <p>
                В соответствии с пунктом 2 статьи 437 Гражданского кодекса Российской Федерации, в случае принятия 
                изложенных ниже условий и совершения действий по оплате услуг, лицо, производящее акцепт этой оферты, 
                становится Заказчиком (в соответствии с пунктом 3 статьи 438 ГК РФ акцепт оферты равносилен заключению 
                договора на условиях, изложенных в оферте).
              </p>
              <p>
                Акцептом настоящей Оферты является совершение Заказчиком действий по оплате услуг Исполнителя 
                в соответствии с условиями, указанными в настоящей Оферте.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Предмет Оферты</h2>
              <p>
                Исполнитель обязуется оказать Заказчику услуги по <strong>разработке программного обеспечения</strong> 
                и <strong>подключению пользователей к разработанному сервису</strong> SkillGate.
              </p>
              <p>
                В рамках оказания услуг по разработке программного обеспечения Исполнитель предоставляет Заказчику 
                доступ к разработанному программному комплексу SkillGate, предназначенному для проведения 
                скрининг-тестирования кандидатов.
              </p>
              <p>
                Услуги по подключению к разработанному сервису включают в себя:
              </p>
              <ol className="list-decimal pl-6 space-y-4">
                <li>
                  <strong>Подключение к сервису тестирования кандидатов</strong> — предоставление доступа к функционалу 
                  информационной системы SkillGate для проведения скрининг-тестирования кандидатов. Услуга может предоставляться:
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Поштучно (за каждого протестированного кандидата);</li>
                    <li>Пакетом (за определенное количество тестирований).</li>
                  </ul>
                </li>
                <li>
                  <strong>Разработка и подключение базы данных вопросов</strong> — разработка программного модуля 
                  (базы данных вопросов) для конкретной специальности и его интеграция в систему SkillGate. 
                  База вопросов создается на основе требований Заказчика и включает вопросы различной сложности 
                  с вариантами ответов и правильными ответами.
                </li>
              </ol>
              <p>
                Детальное описание услуг, их стоимость и условия оказания размещены на сайте 
                <a href="https://skillgate.pro" className="text-blue-600 hover:underline"> https://skillgate.pro</a> 
                и могут изменяться Исполнителем в одностороннем порядке.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Сведения об Исполнителе</h2>
              <p>
                <strong>Индивидуальный предприниматель Вихляев Сергей Николаевич</strong>
              </p>
              <p>
                ИНН: 682004283576
              </p>
              <p>
                Адрес электронной почты: <a href="mailto:skillgate.pro@gmail.com" className="text-blue-600 hover:underline">skillgate.pro@gmail.com</a>
              </p>
              <p>
                Сайт: <a href="https://skillgate.pro" className="text-blue-600 hover:underline">https://skillgate.pro</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Порядок оплаты</h2>
              <p>
                Оплата услуг производится посредством <strong>Системы быстрых платежей (СБП)</strong> по реквизитам 
                или QR-коду, предоставляемым Исполнителем.
              </p>
              <p>
                Валидация платежа производится в течение <strong>24 часов</strong> с момента совершения платежа. 
                После подтверждения оплаты услуги считаются оказанными и доступными для использования Заказчиком.
              </p>
              <p>
                В случае отсутствия подтверждения платежа в течение 24 часов Заказчик вправе обратиться к 
                Исполнителю для уточнения статуса платежа.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Сроки оказания услуг</h2>
              <p>
                <strong>Для услуги «Подключение к сервису тестирования кандидатов»:</strong> услуга считается оказанной 
                с момента предоставления доступа к результатам тестирования в разработанном программном комплексе SkillGate.
              </p>
              <p>
                <strong>Для услуги «Разработка и подключение базы данных вопросов»:</strong> срок оказания услуги 
                определяется индивидуально в зависимости от объема и сложности разрабатываемого программного модуля 
                и согласовывается с Заказчиком до начала оказания услуги. Как правило, срок составляет от 3 до 14 рабочих дней.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Права и обязанности сторон</h2>
              <p>
                <strong>Исполнитель обязуется:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Оказать услуги по разработке программного обеспечения и подключению к разработанному сервису 
                в соответствии с условиями настоящей Оферты;</li>
                <li>Обеспечить качественное выполнение услуг;</li>
                <li>Предоставить доступ к разработанному программному комплексу SkillGate и результатам оказанных услуг;</li>
                <li>Хранить все данные на территории Российской Федерации.</li>
              </ul>
              <p>
                <strong>Заказчик обязуется:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Своевременно оплатить услуги в соответствии с условиями настоящей Оферты;</li>
                <li>Предоставить Исполнителю всю необходимую информацию для оказания услуг по разработке программного обеспечения;</li>
                <li>Соблюдать условия использования разработанного программного комплекса SkillGate.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Ответственность сторон</h2>
              <p>
                Исполнитель несет ответственность за качество оказываемых услуг в соответствии с законодательством 
                Российской Федерации.
              </p>
              <p>
                Исполнитель не несет ответственности за:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Решения, принятые Заказчиком на основе результатов тестирования кандидатов;</li>
                <li>Невозможность оказания услуг вследствие действий третьих лиц или форс-мажорных обстоятельств;</li>
                <li>Ущерб, причиненный Заказчику в результате использования результатов услуг.</li>
              </ul>
              <p>
                Заказчик несет ответственность за достоверность предоставленной информации и за соблюдение 
                законодательства Российской Федерации при использовании услуг.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Возврат средств</h2>
              <p>
                Возврат денежных средств за оплаченные услуги производится в следующих случаях:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Отказ Исполнителя от оказания услуг по причинам, не зависящим от Заказчика;</li>
                <li>Невозможность оказания услуг вследствие обстоятельств непреодолимой силы;</li>
                <li>Нарушение Исполнителем сроков оказания услуг более чем на 50% от согласованного срока 
                (для услуги «Разработка и подключение базы данных вопросов»).</li>
              </ul>
              <p>
                Возврат денежных средств не производится в случае, если услуга была оказана в полном объеме 
                и Заказчик получил доступ к результатам услуги.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Конфиденциальность и защита данных</h2>
              <p>
                Все данные, обрабатываемые в рамках оказания услуг, хранятся на территории Российской Федерации. 
                Хостинг-провайдером является ООО «Регистратор доменных имен РЕГ.РУ» (reg.ru).
              </p>
              <p>
                Исполнитель обязуется не разглашать конфиденциальную информацию Заказчика и применять меры 
                по защите данных в соответствии с законодательством Российской Федерации.
              </p>
              <p>
                Разработанный программный комплекс SkillGate <strong>не предназначен для обработки персональных данных</strong> 
                в понимании Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Изменение и расторжение Оферты</h2>
              <p>
                Исполнитель вправе в одностороннем порядке изменять условия настоящей Оферты. Актуальная версия 
                Оферты всегда доступна на странице 
                <a href="https://skillgate.pro/public-offer" className="text-blue-600 hover:underline"> https://skillgate.pro/public-offer</a>.
              </p>
              <p>
                Изменения вступают в силу с момента их опубликования на сайте, если иное не указано Исполнителем.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Разрешение споров</h2>
              <p>
                Все споры и разногласия, возникающие между сторонами в связи с исполнением настоящей Оферты, 
                разрешаются путем переговоров. В случае невозможности достижения согласия споры подлежат 
                разрешению в судебном порядке в соответствии с законодательством Российской Федерации.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Заключительные положения</h2>
              <p>
                Настоящая Оферта вступает в силу с момента ее опубликования на сайте 
                <a href="https://skillgate.pro" className="text-blue-600 hover:underline"> https://skillgate.pro</a> 
                и действует до момента отзыва Оферты Исполнителем.
              </p>
              <p>
                Настоящая Оферта регулируется законодательством Российской Федерации.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">13. Контактная информация</h2>
              <p>
                По всем вопросам, связанным с оказанием услуг, Заказчики могут обращаться к Исполнителю:
              </p>
              <p>
                Электронная почта: <a href="mailto:skillgate.pro@gmail.com" className="text-blue-600 hover:underline">skillgate.pro@gmail.com</a>
              </p>
              <p>
                Сайт: <a href="https://skillgate.pro" className="text-blue-600 hover:underline">https://skillgate.pro</a>
              </p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-gray-200 text-sm text-gray-500">
            <p>Дата последнего обновления: 17 января 2025 г.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicOffer;

